<template>
  <q-page padding>
    <div class="row col-12 justify-between">
      <div>
        <p class="text-h6 text-weight-bold text-brand-1 texto-titulo">
          Detalhe Menu: {{ submenuId }}
        </p>
      </div>
      <div>
        <router-link :to="{ name: 'backoffice-gestao-menu' }">
          <div
            style="cursor: pointer"
            class="row items-center text-weight-bold text-brand-1 q-mr-md container-link-voltar"
          >
            <q-icon class="q-mr-sm icon-voltar" name="west" color="brand-1" />
            <span class="texto-titulo">Voltar</span>
          </div>
        </router-link>
      </div>
    </div>
    <div class="row q-ml-md col-12 q-mt-xl">
      <div class="col q-mr-md">
        <div
          style="font-size: 18px"
          class="q-mb-lg text-brand-1 text-weight-medium"
        >
          <span
            >Utilize os campos para filtrar a lista de submenus
            (Disponíveis)</span
          >
        </div>
        <div
          class="row col-12 text-brand-1 text-weight-bold q-gutter-sm q-mb-sm"
        >
          <div class="col">
            <div>Nome</div>
            <q-input
              debounce="500"
              v-model="paginasFiltrosCriadas.nome"
              dense
              outlined
            />
          </div>
          <div class="col">
            <div>Rota</div>
            <q-input
              debounce="500"
              v-model="paginasFiltrosCriadas.rota"
              dense
              outlined
            />
          </div>
          <div class="col">
            <div>Descrição</div>
            <q-input
              debounce="500"
              v-model="paginasFiltrosCriadas.descricao"
              dense
              outlined
            />
          </div>
        </div>
        <q-linear-progress v-if="loadingPagina" indeterminate size="3px" />
        <q-table
          class="my-sticky-dynamic"
          :columns="columnsPaginasNaoVinculadas"
          :rows="listaPaginas"
          row-key="nome"
          dense
          v-model:pagination="pagination"
          selection="multiple"
          v-model:selected="paginasSelecionadas"
          no-data-label="Nenhuma página criada."
          :hide-bottom="listaPaginas?.length > 0"
          flat
        >
          <template v-slot:header="props">
            <q-tr :props="props">
              <q-th v-for="col in props.cols" :key="col.name" :props="props">
                <span>{{ col.label }}</span>
              </q-th>
            </q-tr>
          </template>
          <template v-slot:body="props">
            <q-tr
              :style="
                props.selected
                  ? 'background-color: #f1f1f1; color: #8A8A8A'
                  : ''
              "
            >
              <q-td>
                {{ props.row.nome }}
              </q-td>
              <q-td>
                {{ props.row.rota }}
              </q-td>
              <q-td>
                {{ props.row.descricao }}
              </q-td>
              <q-td class="coluna-btn">
                <q-btn
                  class="q-ml-sm"
                  icon="add"
                  flat
                  :color="props.selected ? '#8A8A8A' : 'positive'"
                  :disable="props.selected || disable"
                  round
                  @click="vincularPagina(props.row)"
                />
              </q-td>
            </q-tr>
          </template>
        </q-table>
        <div
          v-if="listaPaginas.length > 14 || pagination.page > 1"
          class="row justify-center q-mt-md"
        >
          <q-pagination
            :disable="disable"
            v-model="pagination.page"
            color="brand-5"
            active-color="secondary"
            active-text-color="white"
            :max="pagesNumber"
            :max-pages="5"
            :boundary-numbers="false"
            :direction-links="true"
            size="sm"
          />
        </div>
      </div>
      <q-separator vertical inset color="grey-4" />
      <div class="col q-ml-md">
        <div
          style="font-size: 18px"
          class="q-mb-lg text-brand-1 text-weight-medium"
        >
          <span
            >Utilize os campos para filtrar a lista de submenus
            (Vinculados)</span
          >
        </div>
        <div
          class="row col-12 text-brand-1 text-weight-bold q-gutter-sm q-mb-sm"
        >
          <div class="col">
            <div>Nome</div>
            <q-input
              debounce="500"
              v-model="paginasFiltrosVinculadas.nome"
              dense
              outlined
            />
          </div>
          <div class="col">
            <div>Rota</div>
            <q-input
              debounce="500"
              v-model="paginasFiltrosVinculadas.rota"
              dense
              outlined
            />
          </div>
          <div class="col">
            <div>Descrição</div>
            <q-input
              debounce="500"
              v-model="paginasFiltrosVinculadas.descricao"
              dense
              outlined
            />
          </div>
        </div>
        <q-linear-progress
          v-if="loadingPaginaVinculadas"
          indeterminate
          size="3px"
        />
        <q-table
          :columns="columnsPaginasVinculadas"
          :rows="paginasSelecionadas"
          row-key="nome"
          dense
          class="my-sticky-dynamic"
          :rows-per-page-options="[0]"
          no-data-label="Nenhuma página vinculada"
          :hide-bottom="paginasSelecionadas?.length > 0"
          flat
        >
          <template v-slot:header="props">
            <q-tr :props="props">
              <q-th v-for="col in props.cols" :key="col.name" :props="props">
                <span>{{ col.label }}</span>
              </q-th>
            </q-tr>
          </template>
          <template v-slot:body="props">
            <q-tr>
              <q-td>
                {{ props.row.nome }}
              </q-td>
              <q-td>
                {{ props.row.rota }}
              </q-td>
              <q-td>
                {{ props.row.descricao }}
              </q-td>
              <q-td class="coluna-btn">
                <q-btn
                  icon="close"
                  class="q-ml-sm"
                  flat
                  round
                  :disable="disable"
                  color="red"
                  @click="desvincularPagina(props.row)"
                />
              </q-td>
            </q-tr>
          </template>
        </q-table>
      </div>
    </div>
    <div class="row col-12 q-mt-xl q-ml-md">
      <div>
        <q-btn
          icon="add"
          no-caps
          color="brand-1"
          label="Adicionar Perfil/Cliente"
          @click="modal = true"
        />
      </div>
    </div>
    <ModalInformacaoesAdicionais
      :rightDrawerOpen="modal"
      :nomeModal="'Vincular Perfil/Cliente'"
      :classTitulo="'text-brand-1'"
      @fecharModal="modal = false"
    >
      <template v-slot:conteudo-modal>
        <div class="text-brand-1">
          <div>
            <SelecaoClientes
              :model="submenu.cliente"
              @enviarCliente="receberCliente"
            />
          </div>
          <div class="q-mt-sm">
            <div>Perfil</div>
            <q-select
              @filter="filtrarPerfis"
              :options="listaPerfis"
              dense
              v-model="submenu.perfil"
              use-input
              option-label="perfil"
              option-value="perfil"
              outlined
            />
          </div>
          <div class="q-mt-sm">
            <div>Nome Visualização</div>
            <q-input v-model="submenu.nomeVisualizacao" dense outlined />
          </div>
          <div class="q-mt-sm">
            <div>Índice</div>
            <q-input v-model="submenu.indice" type="number" dense outlined />
          </div>
        </div>
      </template>
      <template v-slot:botao-modal>
        <q-btn
          icon="add"
          no-caps
          label="Criar"
          color="positive"
          @click="vincularPerfilCliente()"
        />
      </template>
    </ModalInformacaoesAdicionais>
    <div class="q-mt-xl q-ml-md">
      <div
        style="font-size: 18px"
        class="q-mb-lg text-brand-1 text-weight-medium"
      >
        <span>Utilize os campos para filtrar a lista de Perfil/Cliente</span>
      </div>
      <div class="row col-12 text-brand-1 text-weight-bold q-gutter-sm q-mb-sm">
        <div>
          <div>Cliente</div>
          <q-input
            debounce="500"
            v-model="perfilClienteFiltros.cliente"
            dense
            outlined
          />
        </div>
        <div>
          <div>Perfil</div>
          <q-input
            debounce="500"
            v-model="perfilClienteFiltros.perfil"
            dense
            outlined
          />
        </div>
        <div>
          <div>Nome Visualização</div>
          <q-input
            v-model="perfilClienteFiltros.nomeVisualizacao"
            dense
            debounce="500"
            outlined
          />
        </div>
        <div>
          <div>Índice</div>
          <q-input
            debounce="500"
            v-model="perfilClienteFiltros.indice"
            dense
            outlined
          />
        </div>
      </div>
      <q-linear-progress v-if="loadingPerfilCliente" indeterminate size="3px" />
      <q-table
        class="my-sticky-dynamic"
        :columns="columns"
        dense
        :rows-per-page-options="[0]"
        no-data-label="Nenhum perfil/cliente vinculado"
        :hide-bottom="submenuDetalhe?.perfilCliente?.length > 0"
        :rows="listaPerfilCliente"
        flat
      >
        <template v-slot:header="props">
          <q-tr :props="props">
            <q-th v-for="col in props.cols" :key="col.name" :props="props">
              <span>{{ col.label }}</span>
            </q-th>
          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr>
            <q-td>
              {{ props.row.cliente }}
            </q-td>
            <q-td>
              {{ props.row.perfil }}
            </q-td>
            <q-td>
              {{ props.row.nomeVisualizacao }}
            </q-td>
            <q-td>
              {{ props.row.indiceSubmenu }}
            </q-td>
            <q-td class="coluna-btn">
              <q-btn
                class="q-ml-md"
                icon="close"
                flat
                color="red"
                round
                @click="desvincularPerfilCliente(props.row)"
              />
            </q-td>
          </q-tr>
        </template>
      </q-table>
    </div>
    <div v-if="modal" @click="modal = false" class="mascara"></div>
  </q-page>
</template>

<script>
import { onMounted, ref, watch, computed } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { watchDebounced } from "@vueuse/core";
import ModalInformacaoesAdicionais from "../../requisicao/components/ModalInformacaoesAdicionais.vue";
import SelecaoClientes from "../components/SelecaoClientes.vue";

const columns = [
  {
    name: "cliente",
    label: "Cliente",
    align: "left",
  },
  {
    name: "perfil",
    label: "Perfil",
    align: "left",
  },
  {
    name: "nomeVisualizacao",
    label: "Nome Visualização",
    align: "left",
  },
  {
    name: "indice",
    label: "Índice",
    align: "left",
  },
  {
    name: "desvincular",
    label: "Desvincular",
    align: "left",
  },
];

const columnsPaginasVinculadas = [
  {
    name: "nome",
    label: "Nome",
    align: "left",
  },
  {
    name: "rota",
    label: "Rota",
    align: "left",
  },
  {
    name: "descricao",
    label: "Descrição",
    align: "left",
  },
  {
    name: "desvincular",
    label: "Desvincular",
    align: "left",
  },
];

const columnsPaginasNaoVinculadas = [
  {
    name: "nome",
    label: "Nome",
    align: "left",
  },
  {
    name: "rota",
    label: "Rota",
    align: "left",
  },
  {
    name: "descricao",
    label: "Descrição",
    align: "left",
  },
  {
    name: "vincular",
    label: "Vincular",
    align: "left",
  },
];
export default {
  components: { ModalInformacaoesAdicionais, SelecaoClientes },
  setup() {
    const store = useStore();
    const route = useRoute();
    const quasar = useQuasar();

    const submenuId = route.params.id;
    const modal = ref(false);
    const listaPerfis = ref([]);
    const submenuDetalhe = ref({});
    const submenu = ref({
      perfil: {
        perfil: "",
        descricao: "",
      },
      cliente: {
        clienteId: "",
        ativo: "",
      },
      nomeVisualizacao: "",
      indice: "",
    });
    const listaPaginas = ref([]);
    const paginasSelecionadas = ref([]);
    const listaPerfilCliente = ref([]);
    const perfilClienteFiltros = ref({
      perfil: "",
      cliente: "",
      indice: "",
      nomeVisualizacao: "",
    });
    const paginasFiltrosCriadas = ref({
      nome: "",
      rota: "",
      descricao: "",
    });
    const paginasFiltrosVinculadas = ref({
      nome: "",
      rota: "",
      descricao: "",
    });
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 6,
    });
    const loadingPerfilCliente = ref(false);
    const loadingPaginaVinculadas = ref(false);
    const loadingPagina = ref(false);
    const disable = ref(false);

    const detalharSubmenu = async () => {
      disable.value = true;
      try {
        const response = await store.dispatch("office/detalharSubmenu", {
          submenuId,
        });

        submenuDetalhe.value = response.data.resultado.dados;
        filtrarTabelaPerfilCliente();
        filtrarTabelaPaginasVinculadas();
        disable.value = false;
      } catch (error) {
        console.log(error);
        disable.value = false;
      }
    };

    const listarPerfilCliente = async (val) => {
      if (submenu.value.cliente.clienteId === "") {
        quasar.notify({
          message: "O campo cliente não pode ser vazio.",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      try {
        const response = await store.dispatch("office/listarPerfilCliente", {
          clienteId: submenu.value.cliente.clienteId,
        });
        listaPerfis.value = response.data.resultado.dados.filter((perfil) => {
          return perfil.perfil.toLowerCase().includes(val.toLowerCase());
        });
      } catch (error) {
        console.log(error);
      }
    };

    const vincularPerfilCliente = async () => {
      if (
        submenu.value.cliente.clienteId === "" ||
        submenu.value.perfil.perfil === ""
      ) {
        quasar.notify({
          message: "Preencha os campos acima.",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      try {
        await store.dispatch("office/vincularPerfilCliente", {
          submenuId,
          perfil: submenu.value.perfil.perfil,
          cliente: submenu.value.cliente.clienteId,
          nomeVisualizacao: submenu.value.nomeVisualizacao,
          indice: submenu.value.indice,
        });

        detalharSubmenu();
        resetarValores();
        modal.value = false;
        quasar.notify({
          message: "Perfil/Cliente vinculado com sucesso.",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        console.log(error);
      }
    };

    const desvincularPerfilCliente = async (value) => {
      try {
        await store.dispatch("office/desvincularPerfilCliente", {
          submenuId,
          perfil: value.perfil,
          cliente: value.cliente,
        });

        detalharSubmenu();
        quasar.notify({
          message: "Perfil/Cliente desvinculado com sucesso.",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        console.log(error);
      }
    };

    const listarPaginas = async (page = 0, perPage = 15) => {
      loadingPagina.value = true;
      disable.value = true;
      try {
        const response = await store.dispatch("office/listarPaginas", {
          page,
          perPage,
          nome: paginasFiltrosCriadas.value.nome,
          rota: paginasFiltrosCriadas.value.rota,
          descricao: paginasFiltrosCriadas.value.descricao,
        });

        listaPaginas.value = response.data.resultado.dados;
        pagination.value.page = response.data.resultado.currentPage;
        pagination.value.rowsNumber = response.data.resultado.total;
        pagination.value.rowsPerPage = response.data.resultado.perPage;
        loadingPagina.value = false;
        disable.value = false;
      } catch (error) {
        console.log(error);
        loadingPagina.value = false;
        disable.value = false;
      }
    };

    const vincularPagina = async (value) => {
      try {
        await store.dispatch("office/vincularPagina", {
          submenuId,
          paginaNome: value.nome,
        });
        detalharSubmenu();
        quasar.notify({
          message: "Submenu vinculado com sucesso.",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        console.log(error);
      }
    };

    const desvincularPagina = async (value) => {
      try {
        await store.dispatch("office/desvincularPagina", {
          submenuId,
          paginaNome: value.nome,
        });
        detalharSubmenu();
        quasar.notify({
          message: "Submenu desvinculado com sucesso.",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        console.log(error);
      }
    };

    const filtrarTabelaPerfilCliente = () => {
      loadingPerfilCliente.value = true;
      listaPerfilCliente.value = submenuDetalhe.value?.perfilCliente.filter(
        (objeto) => {
          return (
            objeto?.perfil
              .toLowerCase()
              .includes(perfilClienteFiltros.value.perfil.toLowerCase()) &&
            objeto?.cliente
              .toLowerCase()
              .includes(perfilClienteFiltros.value.cliente.toLowerCase()) &&
            objeto?.nomeVisualizacao
              .toLowerCase()
              .includes(
                perfilClienteFiltros.value.nomeVisualizacao.toLowerCase()
              ) &&
            objeto?.indiceSubmenu
              .toString()
              .toLowerCase()
              .includes(perfilClienteFiltros.value.indice.toLowerCase())
          );
        }
      );
      loadingPerfilCliente.value = false;
    };

    const filtrarTabelaPaginasVinculadas = () => {
      loadingPaginaVinculadas.value = true;
      paginasSelecionadas.value = submenuDetalhe.value?.submenu?.paginas.filter(
        (objeto) => {
          return (
            objeto?.nome
              .toLowerCase()
              .includes(paginasFiltrosVinculadas.value.nome.toLowerCase()) &&
            objeto?.rota
              .toLowerCase()
              .includes(paginasFiltrosVinculadas.value.rota.toLowerCase()) &&
            objeto?.descricao
              .toLowerCase()
              .includes(paginasFiltrosVinculadas.value.descricao.toLowerCase())
          );
        }
      );
      loadingPaginaVinculadas.value = false;
    };

    const resetarValores = () => {
      submenu.value.cliente.value = {
        clienteId: "",
        ativo: "",
      };
      submenu.value = {
        perfil: {
          perfil: "",
          descricao: "",
        },
        clinte: {
          clienteId: "",
          ativo: "",
        },
        nomeVisualizacao: "",
        indice: "",
      };
    };

    const receberCliente = (value) => {
      submenu.value.cliente = value;
      submenu.value.perfil = {
        perfil: "",
        descricao: "",
      };
    };

    watchDebounced(
      [
        () => perfilClienteFiltros.value.perfil,
        () => perfilClienteFiltros.value.cliente,
        () => perfilClienteFiltros.value.nomeVisualizacao,
        () => perfilClienteFiltros.value.indice,
      ],
      () => {
        filtrarTabelaPerfilCliente();
      },
      { debounce: 400 }
    );

    watchDebounced(
      [
        () => paginasFiltrosCriadas.value.nome,
        () => paginasFiltrosCriadas.value.rota,
        () => paginasFiltrosCriadas.value.descricao,
      ],
      () => {
        listarPaginas();
      },
      { debounce: 400 }
    );

    watchDebounced(
      [
        () => paginasFiltrosVinculadas.value.nome,
        () => paginasFiltrosVinculadas.value.rota,
        () => paginasFiltrosVinculadas.value.descricao,
      ],
      () => {
        filtrarTabelaPaginasVinculadas();
      },
      { debounce: 400 }
    );

    watch(
      () => pagination.value.page,
      () => {
        listarPaginas(pagination.value.page, pagination.value.rowsPerPage);
      }
    );

    onMounted(() => {
      detalharSubmenu();
      listarPaginas();
    });

    return {
      columns,
      columnsPaginasVinculadas,
      columnsPaginasNaoVinculadas,
      submenuId,
      detalharSubmenu,
      modal,
      perfilClienteFiltros,
      submenu,
      resetarValores,
      listaPaginas,
      paginasFiltrosCriadas,
      paginasFiltrosVinculadas,
      listaPerfis,
      listarPaginas,
      vincularPagina,
      desvincularPagina,
      paginasSelecionadas,
      submenuDetalhe,
      vincularPerfilCliente,
      desvincularPerfilCliente,
      disable,
      receberCliente,
      listaPerfilCliente,
      filtrarTabelaPerfilCliente,
      filtrarPerfis(val, update) {
        listarPerfilCliente(val);
        setTimeout(() => {
          update();
        }, 500);
      },
      pagination,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      loadingPerfilCliente,
      loadingPaginaVinculadas,
      loadingPagina,
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
.q-table__top,
thead tr:first-child th {
  background-color: #d9effc;
}

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}

.q-table--loading thead tr:last-child th {
  top: 48px;
}
.my-sticky-dynamic {
  max-height: 400px;
}
thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:last-child th {
  top: 48px;
}
thead tr:first-child th {
  top: 0;
}
tbody tr .coluna-btn {
  width: 120px;
}
.mascara {
  background-color: black;
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  opacity: 0.4;
}
.container-link-voltar {
  margin-right: 10px;
}
.icon-voltar {
  font-size: 25px;
}
.texto-titulo {
  font-size: 20px;
}
tbody tr td {
  white-space: pre-wrap;
}
@media (max-width: 600px) {
  .texto-titulo {
    font-size: 16px;
  }
  .container-link-voltar {
    margin: 5px 0px 0px 0px;
  }
  .icon-voltar {
    font-size: 20px;
    margin-right: 1px;
  }
}
</style>
